import { ClearOutlined } from "@ant-design/icons";
import { isJsonEmbedMessage } from "@dots-projects/types";
import { Button, Tooltip } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { Controller, UseFormReturn } from "react-hook-form";
import { FormLabel } from "./FormLabel";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";

function EmbedMessageInput({
  form,
  name = "message",
  showLabel = false,
  onChangeEmbed = () => {},
}: {
  form: UseFormReturn<any>;
  name?: string;
  showLabel?: boolean;
  onChangeEmbed?: (value: string) => void;
}) {
  const { state } = useTriggerEditorStateDispatch();
  const readOnly = !state.trigger.current.isDraft;

  const {
    control,
    setValue,
    formState: { errors },
  } = form;

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={{
          validate: (value) => isJsonEmbedMessage(value),
        }}
        render={({ field: { onChange, onBlur, value } }) => (
          <>
            {showLabel && <FormLabel label="Embed message" />}
            <p className="text-gray-500 m-0">
              Copy and paste a JSON object here, you can create an embed message
              using an online tool{" "}
              <a
                href="https://glitchii.github.io/embedbuilder/"
                target="_blank"
                rel="noreferrer"
              >
                like this one
              </a>
              .
            </p>
            <Tooltip title="Clear field">
              <Button
                type="default"
                icon={<ClearOutlined />}
                style={{ borderRadius: "99px", margin: "-5px 0 5px 0" }}
                onClick={() => setValue(name, "")}
                size="small"
              />
            </Tooltip>
            <TextArea
              style={{ width: "100%", marginTop: "-10px" }}
              readOnly={readOnly}
              onChange={(e) => {
                onChangeEmbed(e.target.value);
                onChange(e);
              }}
              onBlur={onBlur}
              value={value}
              rows={5}
            />
            {errors[name] && (
              <p className="text-red-500 m-0">
                Embed message is not in the correct format.
              </p>
            )}
          </>
        )}
      />
    </>
  );
}

export default EmbedMessageInput;
